import React from "react";
import { Table } from "reactstrap";
import * as moment from "moment";
import { headerArray, noRecordStyle } from './Constants'

function TableDataDelOrders(props) {
    const { finalData } = props

    return (
        <>
            <Table responsive>
                <thead>
                    <tr>
                        {headerArray.map((items, index) => (
                            <th key={index}>{items.title}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {finalData?.map((items, index) => (
                        <tr key={index}>
                            <td>{items.orderId}</td>
                            <td>{items?.invoiceNumber ? items?.invoiceNumber : "NA"}</td>
                            <td>{items?.invoiceDate ? items?.invoiceDate : "NA"}</td>
                            <td>{items.orderRefNumber ? items.orderRefNumber : ""}</td>
                            <td>{items?.otherPartyInfo}</td>
                            <td>{items?.transportType}</td>
                            <td>{items?.orderType}</td>
                            <td>{items.orderStatus === 'CANCELLED' ? 'CANCELED' : items.orderStatus}</td>
                            <td>{moment(items?.requestedDate).format("MM/DD/YYYY")}</td>
                            <td>{items?.initiatePaymentDate ? moment(items?.initiatePaymentDate).format("MM/DD/YYYY") : 'NA'}</td>
                            <td>{`****${items?.cardInfo}`}</td>
                            <td>{items?.quantity}</td>
                            <td>{items?.totalAmount == null ? '' : `$ ${items?.totalAmount?.toFixed(2)}`}</td>
                        </tr>
                    ))}

                    {finalData?.length === 0 && (<p style={noRecordStyle}>No Records Found</p>)}
                </tbody>
            </Table>
        </>
    )
}

export default TableDataDelOrders;